module.exports = __webpack_public_path__ + "img/quayThresholdToVehicleBus.7457a02a.svg";